import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _forEach from 'lodash/forEach';
import _keys from 'lodash/keys';
import { AppContext, getClonedData } from 'commons-ui';

import useService from '../../../useService';

import { FORM_FIELD_KEYS } from '../../formConfig';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestCreateApkVersionInfo, requestUploadApk } = useService();

	const cloneApkVersionInfo = async (clonedData: any) => {
		setShowLoader(true);
		try {
			const formData = new FormData();
			_forEach(_keys(clonedData), (key: string) => {
				formData.append(key, clonedData[key]);
			});
			const result = await requestUploadApk(formData);
			const apkLinkUrl = _get(result, ['data', 'apkLinkUrl']);

			const cloneApkFinalData = { ...clonedData, apkLinkUrl };

			await requestCreateApkVersionInfo(cloneApkFinalData);
			showAlert('Apk Version cloned');
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(true);
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		cloneApkVersionInfo(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: getClonedData(_get(location, ['state', 'rowData']), FORM_FIELD_KEYS),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
